export const runAiDiscover = async (params, authHeaderValue) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URI}/v1/admin/places/draft/ai-discover`,
    {
      method: "POST",
      headers: {
        Authorization: authHeaderValue,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    },
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(
      err.message || `Request failed with status ${response.status}`,
    );
  }
  return response.json();
};
